import axios from 'axios'

export default {
    auth(code, password) {
        return axios.post('/channel-auth', {
            code: code,
            password: password,
        })
    }
}
